import { z } from "zod";
import { usePlatform } from "@platform//PlatformContext";
import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";
import { FieldType } from "@shared/features/form/Form";
import { baseSupportSchema } from "@shared/schemas/sharedSchemas";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { FormDialog } from "@shared/features/form/FormDialog";

export function SupportTicketFormContainer() {
  const { user } = usePlatform();

  const schema = baseSupportSchema;

  const fields = makeFormFields(["email", "message"]).map((field) => ({
    ...field,
    required: true,
  }));

  const submitSupportTicket = useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      try {
        return await apiRequest(
          "/api/send-support-ticket/",
          "POST",
          data,
          false
        );
      } catch (error) {
        throw error;
      }
    },
  });

  return (
    <FormDialog
      dialogName="supportTicket"
      defaultValues={{
        email: user?.email,
      }}
      title="Get Help"
      description="Send us a message, we'll get back to you as soon as possible."
      successTitle="Success!"
      successDescription="Thank you, we'll get back to you shortly."
      schema={schema}
      fields={fields as FieldType[]}
      onSubmit={submitSupportTicket.mutateAsync}
    />
  );
}

export default SupportTicketFormContainer;
